import type { ReactFCC } from 'types/react';
import type { EditorState } from 'draft-js';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { BoldIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const BoldButton: ReactFCC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('BOLD', editorState)} onClick={onClick}>
        <BoldIcon />
    </Button>
);
